import { Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import { MoneyInput } from "server/components/Fields/MoneyInput";

// Mirrors the backend rule: a fee counts as set only when it is greater than 0
export const hasFee = value => Number(value) > 0;

const HELPER_TEXT = "Въведете месечна или годишна такса";

// Monthly and annual fee are mutually exclusive: filling one disables the other
export const MonthlyOrAnnualFeeInputs = ({ monthlySource, annualSource, monthlyLabel, annualLabel }) => {
  const hasMonthly = hasFee(useWatch({ name: monthlySource }));
  const hasAnnual = hasFee(useWatch({ name: annualSource }));

  return (
    <>
      <Grid
        item
        xs={12}
        md={6}
      >
        <MoneyInput
          source={monthlySource}
          label={monthlyLabel}
          // Keep enabled while it still has a value, so legacy records with both fees can be fixed
          disabled={hasAnnual && !hasMonthly}
          helperText={HELPER_TEXT}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <MoneyInput
          source={annualSource}
          label={annualLabel}
          disabled={hasMonthly && !hasAnnual}
          helperText={HELPER_TEXT}
        />
      </Grid>
    </>
  );
};
